import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Textarea - Glass Greenhouse Design System
 * 
 * Changes from default Shadcn:
 * - Rounded-xl (matching Input)
 * - Stone-50 background tint
 * - Focus states with green ring
 */
const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[100px] w-full rounded-xl border border-stone-200 bg-stone-50/50 px-4 py-3 text-base shadow-soft-sm transition-all duration-200",
        "placeholder:text-muted-foreground",
        "focus-visible:outline-none focus-visible:bg-white focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary/50",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "md:text-sm resize-none",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
